import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-mall-datapack",
  "use": "icon-soc-mall-datapack-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-mall-datapack\">\n<g fill=\"none\" stroke=\"currentColor\" stroke-width=\"48\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n  <rect x=\"220\" y=\"180\" width=\"584\" height=\"664\" rx=\"48\" />\n  <path d=\"M340 340h344M340 480h344M340 620h240\" />\n  <circle cx=\"700\" cy=\"620\" r=\"36\" fill=\"currentColor\" stroke=\"none\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-mall-datapack.svg
// module id = SaXN
// module chunks = 546